import { Button, Checkbox, Text } from '@chakra-ui/react';
import { CSSProperties } from 'react';
import { UseFilterConfigs } from '../useFilterConfigs';

interface ValueCheckboxProps {
  // title: string;
  valueKey?: string;
  visibleValue: string;
  style: CSSProperties;
  isIndeterminate?: boolean;
  isSelected: boolean;
  isDisabled?: boolean;
  onSelect: UseFilterConfigs['selectValue'];
}
const ValueCheckbox: React.FC<ValueCheckboxProps> = ({
  valueKey = '',
  visibleValue,
  style,
  isIndeterminate,
  isSelected,
  isDisabled,
  onSelect,
}) => {
  return (
    <Button
      //   key={index}
      style={style}
      overflow="hidden"
      width="100%"
      variant="ghost"
      textAlign="left"
      justifyContent="flex-start"
      iconSpacing="0"
      padding="0px 5px"
      fontWeight="normal"
      rounded="2xl"
      isDisabled={isDisabled}
      onClick={() => onSelect(valueKey, visibleValue, !isSelected)}
    >
      <Checkbox
        isChecked={isSelected}
        isIndeterminate={isIndeterminate}
        variant="circular"
        size="lg"
        pointerEvents="none"
        // onChange={(e) => setCheckedItems([e.target.checked, e.target.checked])}
      >
        <Text fontSize="14px">{visibleValue}</Text>
      </Checkbox>
    </Button>
  );
};

export default ValueCheckbox;
